// An entry in a priority traversal list that stands for the component type's
// Default overview, which has no traversal id of its own.
export const DEFAULT_OVERVIEW_PRIORITY_TRAVERSAL_ENTRY = 'defaultOverview';

// The ordered list of traversals pinned for one component type. Each entry is
// a traversal id or DEFAULT_OVERVIEW_PRIORITY_TRAVERSAL_ENTRY.
export type APIPriorityTraversal = {
  componentTypeName: string;
  entries: string[];
};
